import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { UserStats } from '../interfaces/user-stats.interface';

@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(http);
  }

  /**
   * Fetch user stats from /user-stats.
   */
  getUserStats(): Observable<UserStats> {
    const url = `${this.baseUrl}/user-stats`;
    return this.http.get<UserStats>(url, { headers: this.getAuthHeaders() });
  }

  /**
   * Fetch statistics (reporting) for the connected patient by passport number.
   * The endpoint is: /prestations/statistics/{passportNumber}
   *
   * Note: Caller should provide the passportNumber (e.g., from store selectCurrentUser | userData.passportNumber)
   */
  getStatistics(passportNumber: string): Observable<any> {
    const url = `${this.baseUrl}/prestations/statistics/${passportNumber}`;
    return this.http.get<any>(url, { headers: this.getAuthHeaders() });
  }

  /**
   * Fetch contract-specific statistics by contractId.
   * Endpoint: /insurances/contracts/{contractId}/statistics
   */
  getContractStatistics(contractId: string): Observable<any> {
    const url = `${this.baseUrl}/insurances/contracts/${contractId}/statistics`;
    return this.http.get<any>(url, { headers: this.getAuthHeaders() });
  }

  /**
   * Fetch important (favorite) documents for a user by passport number.
   * Endpoint: /documents/{passportNumber}?page=1&limit=10&favoritesOnly=true
   */
  getImportantDocuments(passportNumber: string, page: number = 1, limit: number = 10): Observable<any> {
    const url = `${this.baseUrl}/documents/${passportNumber}?page=${page}&limit=${limit}&favoritesOnly=true`;
    return this.http.get<any>(url, { headers: this.getAuthHeaders() });
  }
}
